import React from 'react';
import { Clock, Leaf, ShieldCheck, MapPin } from 'lucide-react';
const values = [{
  title: 'Fast Scheduling',
  description: 'Most jobs booked within 48 hours.',
  icon: Clock
}, {
  title: 'Eco-Friendly Products',
  description: 'Safe for your family, pets, and landscaping.',
  icon: Leaf
}, {
  title: 'Satisfaction Guaranteed',
  description: 'If it is not right, we make it right.',
  icon: ShieldCheck
}, {
  title: 'Locally Owned',
  description: 'Not a franchise. Real people who care.',
  icon: MapPin
}];
export function WhyChooseUs() {
  return <section className="py-20 md:py-24 bg-muted/30" data-id="element-180">
      <div className="container mx-auto px-4 md:px-6" data-id="element-181">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 max-w-7xl mx-auto" data-id="element-182">
          {values.map((value, index) => {
          const Icon = value.icon;
          return <div key={index} className="flex flex-col items-center text-center group" data-id="element-183">
                <div className="w-20 h-20 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-border" data-id="element-184">
                  <Icon className="w-10 h-10 text-accent" data-id="element-185" />
                </div>
                <h3 className="font-heading text-2xl font-bold text-primary mb-3" data-id="element-186">
                  {value.title}
                </h3>
                <p className="text-muted-foreground text-lg" data-id="element-187">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}